'use client';

// eslint-disable-next-line no-restricted-imports
export { sendGTMEvent } from '@next/third-parties/google';
